<!-- Copyright: Seán I. O'Donoghue -->
<!-- The Zoom meeting on /live (EventItem.vue): shown on the first session live now, in its
     countdown's place. Join Meeting opens Zoom's join page in a new tab, which opens the Zoom app
     or offers to join in the browser; as the button first appears, the Join the Meeting dialog
     opens by itself, once per visit. /live shows sessions only to signed-in registrants
     (Live.vue), so only they see it. -->

<template>
  <div v-if="meeting" class="meetingLinks">
    <a :href="meeting.webUrl" data-same-tab @click.prevent="openInNewTab">
      <!-- at check-in the meeting hasn't begun: people check in (Seán, 2026-11-03) -->
      <ButtonBespoke outstanding>{{ isCheckIn ? "Check In" : "Join Meeting" }}</ButtonBespoke>
    </a>
    <JoinMeeting :meeting="meeting" />
  </div>
</template>

<script setup>
import {computed, onMounted, onUnmounted} from "vue";
import ButtonBespoke from "@/components/ButtonBespoke";
import JoinMeeting from "@/components/ModalDialog/JoinMeeting";
import {markJoined} from "@/composables/useLiveMeeting";

const props = defineProps({
  eventName: {type: String, default: ""}, // "Masterclass 2026" or "VIZBI 2026" (the Workshop)
  isCheckIn: {type: Boolean, default: false}, // the event's check-in: no dialog, Check In
  isOpening: {type: Boolean, default: false} // the first session after check-in (the dialog's)
});

// each event's Zoom meeting, one for all its sessions (the Workshop's to come)
const MEETINGS = {
  Masterclass: {id: "84820156897", pwd: "P81e0spJrqfvnAjvWG5E3G6CC0tt6c.1", host: "us06web.zoom.us"}
};

function getMeeting(eventName, isOpening, isCheckIn) {
  const meeting = MEETINGS[String(eventName).startsWith("Masterclass") ? "Masterclass" : "Workshop"];
  if (!meeting) return null;
  const webUrl = `https://${meeting.host}/j/${meeting.id}?pwd=${meeting.pwd}`;
  return {eventName, isOpening, isCheckIn, webUrl};
}

const meeting = computed(() => {
  return getMeeting(props.eventName, props.isOpening, props.isCheckIn);
});

function openInNewTab() {
  markJoined(props.eventName);
  window.open(meeting.value.webUrl, "_blank", "noopener");
}

// while a session is live, the tab says so (seen in the tab bar when it's in the background)
let previousTitle = "";
onMounted(() => {
  previousTitle = document.title;
  document.title = `● Live now · ${previousTitle}`;
});
onUnmounted(() => {
  document.title = previousTitle;
});
</script>

<style scoped>
/* the one thing to click while a session is on: the full width of its column, at full brand
   strength (DESIGN.md § 5: "you should press this") */
.meetingLinks a {
  display: block;
  width: 100%;
}
.meetingLinks > a :deep(button) {
  width: 100%;
  padding: 12px;
  font-size: 1.6rem;
  line-height: 1.2;
  font-weight: 700;
  color: white;
  background-color: var(--brand-dark-color);
}
.meetingLinks > a :deep(button:hover) {
  filter: brightness(1.15);
}
</style>
